/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSendBackward: {
  name: 'send-backward';
  data: string;
} = {
  name: 'send-backward',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5C1.62.5.5 1.617.5 2.998V12a.5.5 0 0 0 1 0V2.998C1.5 2.17 2.171 1.5 3 1.5h9a.5.5 0 0 0 0-1H3Zm2 3A1.5 1.5 0 0 0 3.5 5v9A1.5 1.5 0 0 0 5 15.5h9a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 14 3.5H5ZM4.5 5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
